import { useState } from "react";
import getRoman from "./util/getRoman.js";
import equiv from "./util/equiv.js";
import useSkelephunks from "./hooks/useSkelephunks.js";
import useNFTCollection from "./hooks/useNFTCollection.js";
import useObituary from "./hooks/useObituary.js";
import { useAccount } from "wagmi";

export default function Thumbnail({ collection, tokenID, onClick, active, label = true }) {
    const handleClick = (n) => {
        onClick(tokenID);
    }
    const { isConnected, address: wallet } = useAccount()
    const { obituary } = useObituary();
    const pfpToken = obituary.getToken(wallet);
    const isPFP = isConnected && pfpToken == tokenID;
    const symbol = collection.symbol();
    const meta = collection.getMetadata(tokenID);
    const isKey = equiv(symbol, 'SKEYS')
    const isLocked = equiv(symbol, 'MYSKELE')
    const idString = isKey ? getRoman(tokenID) : `#${tokenID}`;
    const KEY_IMG = '/images/SKELEKEY.gif';
    const TOKEN_IMG = '/images/spinner.gif';
    const ACTIVE_IMG = '/images/demo/dark/blank.gif';
    const image = meta?.image;
    const [imgSRC, setImgSRC] = useState(image || (isKey ? KEY_IMG : TOKEN_IMG));
    const [img] = useState(new Image());
    if (image && !equiv(imgSRC, image)) {
        img.onload = () => {
            setImgSRC(image);
        }
        img.src = image;
    }
    return (
        <div onClick={handleClick} className={'thumbnail'} style={{ marginBottom: label ? 0 : '1rem' }} >
            <div style={{ position: 'relative' }}>{isPFP && <div title='This is your PFP' style={{ position: "absolute", bottom: '.5rem', right: '.5rem' }}>👤</div>}
                <img
                    src={active ? (isKey ? KEY_IMG : ACTIVE_IMG) : imgSRC}
                    loading="lazy"
                    alt=""
                    className={isKey ? 'key-image' : 'profile-picture'}
                />
            </div>
            {label && <h1 style={isPFP ? { color: 'rgb(3, 255, 255)' } : {}} className={`${isKey ? 'key-id' : 'id-number'} ${isLocked ? 'sealed-at' : ''}`}>{idString}</h1>}
        </div>
    )
}